import { useEffect } from "react";
import { Route, Routes as BrowserRoutes, useLocation } from "react-router-dom";
import Home from "./pages/home";
import NotFound from "./pages/notFound";
import "./App.css";
import FinancialProducts from "./pages/financialProducts";
import Seo from "./components/seo";
import Strings from "./utils/stringUtil";
import Navbar from "./components/navbar";
import theme from "../src/utils/themeUtil";
import Footer from "./components/footer";
import { Box } from "@mui/material";
import Faq from "./pages/faq";
import CommunityGuideline from "./pages/communityGuideline";
import PrivacyPolicy from "./pages/privacyPolicy";
import CookiePolicy from "./pages/cookiePolicy";
import Tnc from "./pages/tnc";
import Contact from "./pages/contact";
import RupeeCircleTnc from "./pages/rupeeCircleTnc";
import TranscorpTnc from "./pages/transcorpTnc";
import { ScrollToTop, getQueryParam } from "./utils/util";
import branch from "branch-sdk";
import useWOW from "./utils/wowUtil";
import Payments from "./components/payments";
import Routes from "./utils/routesUtil";
import BusinessLoan from "./pages/businessLoan";
import GrievancePolicy from "./pages/grievancePolicy";

function App() {
  const pathname = useLocation()?.pathname;
  const isBusinessLoanPage = pathname === Routes.MAHILA_LOAN;
  const branchKey = process.env.REACT_APP_BRANCH_URL;
  const branchMatchId = getQueryParam("_branch_match_id");
  useWOW();

  /* initialize branch sdk */
  useEffect(() => {
    if (branchMatchId) {
      branch.init(branchKey, function (err, data) {
        if (data?.data_parsed?.deep_link_url) {
          window.location.href = data.data_parsed.deep_link_url;
        } else {
          window.location.href = Routes.NOT_FOUND;
        }
      });
    }
  }, [branchMatchId, branchKey]);



  return (
    <Box className="App">
      <ScrollToTop />
      {/* Default title and description */}
      <Seo
        title={Strings.homeMetaTitle}
        description={Strings.homeMetaDescription}
        keywords={Strings.homeMetaKeyword}
      />
      <Navbar
        isBranchRedirection={branchMatchId}
        isBusinessLoanPage={isBusinessLoanPage}
      />
      <BrowserRoutes>
        <Route
          path={Routes.HOME}
          element={branchMatchId ? <Payments /> : <Home />}
        />
        <Route
          path={Routes.FINANCIAL_PRODUCTS}
          element={<FinancialProducts />}
        />
        <Route path={Routes.FREQUENTLY_ASKED_QUESTIONS} element={<Faq />} />
        <Route
          path={Routes.COMMUNITY_GUIDELINES}
          element={<CommunityGuideline />}
        />
        <Route path={Routes.PRIVACY_POLICY} element={<PrivacyPolicy />} />
        <Route path={Routes.GRIEVANCE_POLICY} element={<GrievancePolicy />} />

        <Route path={Routes.COOKIE_POLICY} element={<CookiePolicy />} />
        <Route path={Routes.TERMS_CONDITIONS} element={<Tnc />} />
        {/* <Route path="/ppi-terms-and-conditions" element={<PpiTnc />} /> */}
        <Route path={Routes.RUPEE_CIRCLE_TNC} element={<RupeeCircleTnc />} />
        <Route path={Routes.CONTACT_US} element={<Contact />} />
        <Route path={Routes.TRANSCORP_TNC} element={<TranscorpTnc />} />
        <Route path={Routes.MAHILA_LOAN} element={<BusinessLoan />} />
        <Route path={Routes.NOT_FOUND} element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </BrowserRoutes>
      <Box style={{ clear: "both" }}></Box>
      <Footer />
    </Box>
  );
}

export default App;
